import { getDateFormatted, getUpcomingDiffTime } from 'shared/utils/dateTimeUtils';


const getTimeByType = (message, estimatedTime) => {
  const re = new RegExp(/\((.*?)\)/, 'g');
  const matchObj = re.exec(message);

  return (matchObj[1].includes('MINUTES_LEFT'))
    ? getUpcomingDiffTime(estimatedTime)
    : getDateFormatted(estimatedTime, matchObj[1]);
};

const addFormattedTimeToMessage = (estimatedTimeObject, resultMatches) => {
  const tempObj = estimatedTimeObject;
  tempObj.formattedDisplayMessage = estimatedTimeObject.displayMessage;

  for (let i = 0; i < resultMatches.length; i++) {
    if (resultMatches[i][1].includes('MINUTES_LEFT')) {
      tempObj.withTimer = true;
    }

    tempObj.formattedDisplayMessage = tempObj.formattedDisplayMessage.replace(resultMatches[i][0], getTimeByType(resultMatches[i][1], estimatedTimeObject.estimatedTimestamp));
  }

  return tempObj;
};

const parseDisplayMessage = (estimatedTimeObject) => {
  let m;
  const re = new RegExp('{(.*?)}', 'g');
  const resultMatches = [];

  do {
    m = re.exec(estimatedTimeObject.displayMessage);
    if (m) resultMatches.push(m);
  } while (m);

  if (resultMatches.length === 0) {
    const tempObj = estimatedTimeObject;
    tempObj.formattedDisplayMessage = estimatedTimeObject.displayMessage;
    return tempObj;
  }

  return addFormattedTimeToMessage(estimatedTimeObject, resultMatches);
};

export const makeEstimationMessage = (estimatedTimeObject = {}) => {
  const { displayMessage } = estimatedTimeObject;
  if (!displayMessage) return {};

  return parseDisplayMessage(estimatedTimeObject);
};
